export default "__VITE_ASSET__X1PZ2pF2__"